import { RouteComponentProps, withRouter } from 'react-router-dom'

import { createSink } from 'recompose'

// Direct comparison
const pageTitleMap = new Map<string, string>([
  ['/', 'Login'],
  ['/invest/core', 'Invest'],
  ['/settings/linked-accounts/document-uploader', 'Document Upload'],
  ['/document-uploader', 'Document Upload'],
  ['/upload-documents', 'Document Upload'],
  ['/upgrade-success', 'Way to Grow'],
])

// Pattern matching
const pageTitlePatternMap = new Map<RegExp, string>([
  [/\/invest\/later\.*/, 'Later'],
])

export const setPageTitle = ({ location }: RouteComponentProps<{}>) => {
  const pathname = location.pathname.toLowerCase()

  // Default page title and suffix.
  let pageTitle: string | undefined | null = ''
  const pageTitleSuffix = 'Acorns'

  if (pageTitleMap.has(pathname)) {
    pageTitle = pageTitleMap.get(pathname)
  } else {
    Array.from(pageTitlePatternMap.keys()).some((key) => {
      pageTitle = pathname.match(key) && pageTitlePatternMap.get(key)

      return Boolean(pageTitle) // Short circuit if title is found
    })
  }

  if (!pageTitle) {
    // Page title is based on the first component of the pathname.
    // First letter should be capitalized.
    const pathArray = pathname.split('/')
    if (pathArray.length > 1) {
      pageTitle = pathArray[1].charAt(0).toUpperCase() + pathArray[1].substr(1)
    }
  }

  document.title = `${pageTitle} | ${pageTitleSuffix}`
}

export default withRouter(createSink(setPageTitle as any))
